import React from 'react';
import './style.css'; 

const Loader: React.FC = () => {
  return (
    <div className="main">
      <div className="up">
        <div className="loaders">
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} className="loader"></div>
          ))}
        </div>
        <div className="loadersB">
          {Array.from({ length: 9 }).map((_, i) => (
            <div key={i} className="loaderA">
              <div className={`ball${i}`}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Loader;
